import { render, staticRenderFns } from "./down.vue?vue&type=template&id=8c4bee9a&scoped=true&"
import script from "./down.vue?vue&type=script&lang=js&"
export * from "./down.vue?vue&type=script&lang=js&"
import style0 from "./down.vue?vue&type=style&index=0&id=8c4bee9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c4bee9a",
  null
  
)

export default component.exports